<template>
  <v-row justify="center">
    <v-dialog v-model="value" @input="$emit('input')" width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Create payout record</span>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
              <v-combobox
                :items="campaigns"
                :search-input.sync="search"
                :error-messages="selectedCampaignErrors"
                hide-details="auto"
                item-text="name"
                @input="$v.payout.campaign.$touch()"
                @blur="$v.payout.campaign.$touch()"
                v-model="payout.campaign"
                label="Campaign Name"
                dense
                small-chips
                outlined
              >
                <template v-slot:no-data>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>
                        No results matching "
                        <strong>{{ search }}</strong
                        >". Press <kbd>enter</kbd> to create a new one
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-combobox>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-combobox
                :items="clients"
                :search-input.sync="searchClient"
                hide-details="auto"
                v-model="payout.client"
                item-text="name"
                label="Client"
                dense
                small-chips
                outlined
              >
                <template v-slot:no-data>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>
                        No results matching "
                        <strong>{{ searchClient }}</strong
                        >". Press <kbd>enter</kbd> to create a new one
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-combobox>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6" sm="12">
              <!-- <v-text-field label="sss" hide-details single-line outlined dense></v-text-field> -->
              <v-text-field
                label="Receiving Bank A/C No."
                placeholder="Receiving Bank A/C No.(omit dashes)"
                v-model="payout.bankAccountNo"
                :error-messages="bankNoErrors"
                hide-details="auto"
                @input="$v.payout.bankAccountNo.$touch()"
                @blur="$v.payout.bankAccountNo.$touch()"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" sm="12">
              <!-- <v-text-field label="sss" hide-details single-line outlined dense></v-text-field> -->
              <v-text-field
                label="Receiving A/C Name"
                placeholder="Receiving A/C Name."
                :error-messages="receivingNameErrors"
                v-model="payout.receivingName"
                hide-details="auto"
                @input="$v.payout.receivingName.$touch()"
                @blur="$v.payout.receivingName.$touch()"
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6" sm="12">
              <!-- <v-text-field label="sss" hide-details single-line outlined dense></v-text-field> -->
              <v-text-field
                label="Bank Swift Code"
                hide-details
                v-model="payout.bankSwiftCode"
                placeholder="RABONL2U"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" sm="12">
              <!-- <v-text-field label="sss" hide-details single-line outlined dense></v-text-field> -->
              <v-combobox
                :items="statuses"
                hide-details="auto"
                v-model="payout.status"
                label="Status"
                dense
                outlined
              >
              </v-combobox>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6" sm="12">
              <!-- <v-text-field label="sss" hide-details single-line outlined dense></v-text-field> -->
              <v-text-field
                label="Instagram Handle"
                v-model="payout.instagramHandle"
                hide-details="auto"
                :error-messages="instagramHandleErrors"
                @input="$v.payout.instagramHandle.$touch()"
                @blur="$v.payout.instagramHandle.$touch()"
                placeholder="Instagram Handle"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" sm="12">
              <v-combobox
                :items="userCs"
                min-height="30px"
                multiple
                v-model="payout.cs"
                item-text="name"
                hide-details="auto"
                dense
                :search-input.sync="searchCs"
                label="CS Name"
                outlined
                small-chips
              >
                <template v-slot:no-data>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>
                        No results matching "
                        <strong>{{ searchCs }}</strong
                        >". Press <kbd>enter</kbd> to create a new one
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-combobox>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6" sm="12">
              <!-- <v-text-field label="sss" hide-details single-line outlined dense></v-text-field> -->
              <v-text-field
                label="BIB REF"
                placeholder="BK19010043050112"
                v-model="payout.BIBREF"
                hide-details="auto"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" sm="12">
              <!-- <v-text-field label="sss" hide-details single-line outlined dense></v-text-field> -->
              <v-text-field
                label="FT REF"
                v-model="payout.FTREF"
                hide-details="auto"
                placeholder="FT19010043050143"
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6" sm="12">
              <!-- <v-text-field label="sss" hide-details single-line outlined dense></v-text-field> -->
              <v-text-field label="REF" hide-details="auto" v-model="payout.REF" placeholder="KOBE-AN-KW" outlined dense></v-text-field>
            </v-col>
            <v-col cols="12" md="6" sm="12">
              <!-- <v-text-field label="sss" hide-details single-line outlined dense></v-text-field> -->
              <v-text-field label="Billing Contact" hide-details v-model="payout.billingContact" outlined dense></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <!-- <v-text-field label="sss" hide-details single-line outlined dense></v-text-field> -->
              <v-text-field
                label="Amount"
                type="number"
                v-model="payout.amount"
                :error-messages="amountErrors"
                @input="$v.payout.amount.$touch()"
                @blur="$v.payout.amount.$touch()"
                placeholder="300"
                prefix="$"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-menu
                ref="pickDate"
                v-model="pickDate"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="payout.approvalDate"
                    label="Approval Date *"
                    prepend-inner-icon="event"
                    outlined
                    dense
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="payout.approvalDate" no-title scrollable @input="pickDate = false">
                </v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="close">Cancel</v-btn>
          <v-btn color="green darken-1" :disabled="$v.payout.$invalid" text @click="doAction">Submit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import paymentAPIs from './paymentAPIs';
import campaignAPIs from '../Campaign/campaignAPIs';
import userAPIs from '../User/userAPIs';
import clientAPIs from '../Client/clientAPIs';
import config from '@/config';
export default {
  mixins: [validationMixin],
  props: {
    value: Boolean,
    mode: {
      type: String,
      default: 'new'
    },
    data: Object
  },
  validations: {
    payout: {
      campaign: {
        required
      },
      bankAccountNo: {
        required
      },
      receivingName: {
        required
      },
      instagramHandle: {
        required
      },
      approvalDate: {
        required
      },
      amount: {
        required
      }
    }
  },
  data() {
    return {
      payout: {
        bankAccountNo: null,
        csName: null,
        receivingName: null,
        instagramHandle: null,
        BIBREF: null,
        FTREF: null,
        bankSwiftCode: null,
        REF: null,
        status: null,
        billingContact: null,
        campaign: null,
        approvalDate: null,
        amount: null
      },
      pickDate: false,
      userCs: [],
      search: null,
      searchCs: null,
      campaigns: [],
      clients: [],
      searchClient: null,
      sales: [],
      statuses: ['APPROVED', 'PENDING APPROVAL', 'ON_HOLD', 'REJECTED']
    };
  },
  watch: {
    data(newValue) {
      this.payout = Object.assign({}, newValue);
      if (newValue.cs) {
        console.log(newValue.cs);
        newValue.cs = newValue.cs.map(e => {
          if (e && !e.id) {
            e = e.name;
          }
          console.log(e);
          return e;
        });
      }
    },
    'payout.campaign'(newValue) {
      if (newValue && newValue.clientID) {
        this.payout.client = this.filterClientByCampaigns(newValue.clientID);
      }
      if (newValue && newValue.name) {
        if (!this.payout.id) {
          this.payout.cs = this.filterCsByCampaigns(newValue.name);
        }
      }
    }
  },
  computed: {
    selectedCampaignErrors() {
      const errors = [];
      if (!this.$v.payout.campaign.$dirty) return errors;
      !this.$v.payout.campaign.required && errors.push(' This field is required.');
      return errors;
    },
    bankNoErrors() {
      const errors = [];
      if (!this.$v.payout.bankAccountNo.$dirty) return errors;
      !this.$v.payout.bankAccountNo.required && errors.push('This field is required.');
      return errors;
    },
    receivingNameErrors() {
      const errors = [];
      if (!this.$v.payout.receivingName.$dirty) return errors;
      !this.$v.payout.receivingName.required && errors.push('This field is required.');
      return errors;
    },
    instagramHandleErrors() {
      const errors = [];
      if (!this.$v.payout.instagramHandle.$dirty) return errors;
      !this.$v.payout.instagramHandle.required && errors.push('This field is required.');
      return errors;
    },
    csNameErrors() {
      const errors = [];
      if (!this.$v.payout.csName.$dirty) return errors;
      !this.$v.payout.csName.required && errors.push('This field is required.');
      return errors;
    },
    BIBREFErrors() {
      const errors = [];
      if (!this.$v.payout.BIBREF.$dirty) return errors;
      !this.$v.payout.BIBREF.required && errors.push('This field is required.');
      return errors;
    },
    FTREFErrors() {
      const errors = [];
      if (!this.$v.payout.FTREF.$dirty) return errors;
      !this.$v.payout.FTREF.required && errors.push('This field is required.');
      return errors;
    },
    REFErrors() {
      const errors = [];
      if (!this.$v.payout.REF.$dirty) return errors;
      !this.$v.payout.REF.required && errors.push('This field is required.');
      return errors;
    },
    amountErrors() {
      const errors = [];
      if (!this.$v.payout.amount.$dirty) return errors;
      !this.$v.payout.amount.required && errors.push('This field is required.');
      return errors;
    },
    campaignStatus() {
      return Object.values(config.campaignStatus).join();
    }
  },
  mounted() {
    this.fetchCampaigns();
    this.fetchCSs();
    this.fetchClient();
    this.fetchSales();
  },
  methods: {
    doAction() {
      switch (this.mode) {
        case 'new':
          this.create();
          break;
        case 'edit':
          this.update();
          break;
      }
    },
    close() {
      this.$emit('input');
    },
    async create() {
      try {
        const data = this.constructData(this.payout);
        await paymentAPIs.createPayout(data);
        this.$emit('created');
        this.$emit('input');
        this.$swal({
          text: 'New payout record is created',
          type: 'success'
        });
      } catch (error) {
        console.error(error);
        this.$swal({
          text: error.message,
          type: 'error'
        });
      }
    },
    async update() {
      try {
        const data = this.constructData(this.payout);
        const id = data.id;
        if (!id) {
          this.$swal({
            text: 'Record id not found',
            type: 'warning'
          });
          return;
        }
        await paymentAPIs.updatePayout(id, data);
        this.$swal({
          text: 'Updated!',
          type: 'success'
        });
        this.$emit('created');
        this.$emit('input');
      } catch (error) {
        console.error(error);
        this.$swal({
          text: error.message,
          type: 'error'
        });
      }
    },
    async fetchCampaigns() {
      try {
        const resp = await campaignAPIs.getAllCampaigns(this.campaignStatus, false);
        const data = resp.data;
        const campaigns = data.campaigns;
        this.campaigns = campaigns.map(cmp => {
          return {
            name: cmp.name,
            id: cmp.id,
            assignedTo: cmp.assignedTo,
            clientID: cmp.clientID
          };
        });
      } catch (error) {
        console.log(error);
        this.$swal({
          text: 'Cannot fetch the list of campaigns',
          icon: 'error'
        });
      }
    },
    filterClientByCampaigns(clientID) {
      const client = this.clients.find(cmp => cmp.id === clientID);
      return client;
    },
    filterCsByCampaigns(campaignName) {
      if (!campaignName) return null;
      const userCampaign = this.campaigns.find(c => c.name === campaignName)
      if (!userCampaign) return null;
      const cs = this.userCs.filter(user => userCampaign.assignedTo && userCampaign.assignedTo.find(item => user.id === item));
      return cs;
    },
    constructData(input) {
      let data = Object.assign({}, input);
      if (data.cs) {
        data.cs = data.cs.map(element => {
          if (typeof element === 'string') {
            element = {
              name: element
            };
          }
          return element;
        });
      }

      if (typeof data.campaign === 'string') {
        data.campaign = {
          name: data.campaign
        };
      }
      if (typeof data.client === 'string') {
        data.client = {
          name: data.client
        };
      }
      return data;
    },
    async fetchCSs() {
      try {
        const resp = await userAPIs.getAllUsersByRole(config.userRoles.AD_STRATEGIST);
        const users = resp.users;
        this.userCs = users.map(user => {
          return {
            name: `${user.firstName} ${user.lastName}`,
            id: user.id
          };
        });
      } catch (error) {
        console.log(error);
        this.$swal({
          text: 'Cannot fetch the list of CS',
          icon: 'error'
        });
      }
    },
    async fetchClient() {
      try {
        const resp = await clientAPIs.getAllClients(true);
        const clients = resp.data;
        this.clients = clients.map(user => {
          return {
            name: user.name,
            id: user.id
          };
        });
      } catch (error) {
        console.log(error);
        this.$swal({
          text: 'Cannot fetch the list of clients',
          icon: 'error'
        });
      }
    },
    async fetchSales() {
      try {
        const resp = await userAPIs.getAllUsersByRole(config.userRoles.COMPANY_ADMIN_LOW);
        const users = resp.users;
        this.sales = users.map(user => {
          return {
            id: user.id,
            name: `${user.firstName} ${user.lastName}`
          };
        });
      } catch (error) {
        console.log(error);
        this.$swal({
          text: 'Cannot fetch the list of CS',
          icon: 'error'
        });
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// CreatePayoutRecordModal.vue?9085df90